import React, { useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useHistory } from 'react-router-dom';
import ReactSelect from 'react-select';
import { getProvinces, signup } from '../../util/APIUtils';
import { error, success } from '../../util/toast';
import { allow2Oauth } from '../../constants/config';
import SocialSignup from '../social-signup';
import { useQuery } from '../../common/hooks/useQuery';
import { t, Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { DEFAULT_REDIRECT_URI } from '../../constants';
import showPass from '../../assets/img/showPass.svg';
import hidePass from '../../assets/img/hidePass.svg';
import { toast } from 'react-toastify';

import useIsTouchDevice from '../../common/hooks';

const OrganizationForm = (props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();
  const { i18n } = useLingui();
  let history = useHistory();
  const password = useRef({});
  const query = useQuery();
  const { data, lang, redirectParam, type } = props;
  const { fields, nations } = data;

  const isTouchDevice = useIsTouchDevice();

  const [selectedFields, setSelectedFields] = useState([]);
  const [selectedNation, setSelectedNation] = useState(0);
  const [selectedProvinces, setSelectedProvinces] = useState(0);
  const [provinces, setProvinces] = useState([]);

  password.current = watch('password', '');

  const hanldeGetProvinces = (id) => {
    console.log(id);
    getProvinces(id).then((response) =>
      response.json().then((res) => {
        setProvinces(res);
      }),
    );
  };

  const onSubmit = (data) => {
    delete data.repassword;
    if (!data.lastName || data.lastName === '') {
      setError('lastName', 'Bạn chưa nhập họ');
      return;
    }
    if (!data.firstName || data.firstName === '') {
      setError('lastName', 'Bạn chưa nhập tên');
      return;
    }
    if (!data.myCheckbox || data.myCheckbox === false) {
      setError('myCheckbox', 'Bạn phải đồng ý với điều khoản và điều kiện!');
      return;
    }
    delete data.myCheckbox;
    data.listFieldsId = selectedFields?.map((item) => {
      return item.value;
    });
    data.nationId = selectedNation;
    data.provincedId = selectedProvinces;
    const registerAccount = {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      login: data.login,
      listFieldsId: data.listFieldsId,
      password: data.password,
    };
    const registerTenant = {
      name: data.name,
      website: data.website,
      nationId: data.nationId,
      provincedId: data.provincedId,
      orgEmail: data.orgEmail,
      orgAddress: data.orgAddress,
      listDemandId: data.listDemandId,
      listFieldsId: data.listFieldsId,
      listSupplyId: data.listSupplyId,
      type: type == 2 ? 150 : 200,
    };
    const obj = {
      registerAccountDTO: registerAccount,
      bothRegister: true,
      registerTenantDTO: registerTenant,
    };
    signup(obj)
      .then((response) => {
        if (response.status !== 200) {
          throw new Error();
        }
        success(<Trans>Đăng ký thành công , vui lòng đăng nhập</Trans>);
        setTimeout(() => {
          history.push(
            `/login${redirectParam ? `?redirect=${redirectParam}` : ''}`,
          );
        }, 500);
      })
      .catch((err) => {
        error(
          (err && err.detail) || (
            <Trans>Trùng thông tin với tài khoản đã có trong hệ thống</Trans>
          ),
        );
      });
  };
  const [passwordShown, setPasswordShown] = useState(false);
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  const [rePasswordShown, setRePasswordShown] = useState(false);
  const toggleRePasswordVisiblity = () => {
    setRePasswordShown(rePasswordShown ? false : true);
  };

  return (
    <div>
      {!isTouchDevice ? (
        <div className="block">
          <div className="content-register">
            <div
              className=" mb-6"
              style={{ fontWeight: 'bold', fontSize: '36px', color: '#fff' }}
            >
              {type == 2 && (
                <span>
                  <Trans>Đăng ký tài khoản tổ chức giáo dục</Trans>
                </span>
              )}
              {type == 3 && (
                <span>
                  <Trans>Đăng ký tài khoản doanh nghiệp</Trans>
                </span>
              )}
            </div>
            <div className="h-1 mb-8 bg-white" style={{ width: '59px' }}></div>
            <div
              className="font-bold text-white mb-3"
              style={{ fontSize: '22px' }}
            >
              <Trans>Thông tin tài khoản</Trans>
            </div>
            <div className="">
              <form method="post" onSubmit={handleSubmit(onSubmit)}>
                <div className="md:flex w-full mb-8">
                  <div className="md:w-1/2 md:pr-5">
                    <div className="md:flex">
                      <div className="md:mr-2">
                        <span className="block mb-2 text-sm text-white">
                          <Trans>Họ</Trans>
                        </span>
                        <input
                          type="text"
                          id="lastName"
                          className="w-full mb-4 border rounded py-1 px-3 border-gray-300"
                          name="lastName"
                          placeholder={i18n._(`Họ`)}
                          {...register('lastName', {
                            required: i18n._(`Vui lòng điền họ`),
                          })}
                        />
                        <span className="block efname text-red-500 text-xs">
                          {errors.lastName?.message}
                        </span>
                      </div>
                      <div className="md:ml-2">
                        <span className="block mb-2 text-sm text-white">
                          <Trans>Tên</Trans>
                        </span>
                        <input
                          type="text"
                          id="firstName"
                          className="w-full mb-4 border rounded py-1 px-3 border-gray-300"
                          name="firstName"
                          placeholder={i18n._(`Tên`)}
                          {...register('firstName', {
                            required: i18n._(`Vui lòng điền tên`),
                          })}
                        />
                        <span className="block text-red-500 text-xs">
                          {errors.firstName?.message}
                        </span>
                      </div>
                    </div>
                    <div>
                      <span className="block mb-2 text-sm text-white">
                        <Trans>Mật khẩu</Trans>
                      </span>
                      <div className="relative flex">
                        <input
                          id="password"
                          className="w-full mb-4 border rounded py-1 px-3 border-gray-300"
                          name="password"
                          {...register('password', {
                            required: i18n._(`Vui lòng điền mật khẩu`),
                            minLength: {
                              value: 6,
                              message: t`Mật khẩu tối thiểu 6 ký tự`,
                            },
                          })}
                          placeholder={i18n._(`Mật khẩu`)}
                          type={passwordShown ? 'text' : 'password'}
                        />
                        <div
                          onClick={togglePasswordVisiblity}
                          className="absolute right-[13px] translate-y-1/3 -translate-x-1/2"
                        >
                          {passwordShown ? (
                            <img src={showPass} />
                          ) : (
                            <img src={hidePass} />
                          )}
                        </div>
                      </div>
                      <span className="block epassword text-red-500 text-xs">
                        {errors.password?.message}
                      </span>
                    </div>
                    <div>
                      <span className="block mb-2 text-sm text-white">
                        <Trans>Mật khẩu xác nhận</Trans>
                      </span>
                      <div className="relative flex">
                        <input
                          id="repassword"
                          {...register('repassword', {
                            required: i18n._(`Không được để trống`),
                            validate: (value) =>
                              value === password.current ||
                              i18n._(`Mật khẩu không khớp`),
                          })}
                          className="w-full mb-4 border rounded py-1 px-3 border-gray-300"
                          placeholder={i18n._(`Nhập lại mật khẩu`)}
                          type={rePasswordShown ? 'text' : 'password'}
                        />
                        <div
                          onClick={toggleRePasswordVisiblity}
                          className="absolute right-[13px] translate-y-1/3 -translate-x-1/2"
                        >
                          {rePasswordShown ? (
                            <img src={showPass} />
                          ) : (
                            <img src={hidePass} />
                          )}
                        </div>
                      </div>
                      <span className="block erepassword text-red-500 text-xs">
                        {errors.repassword?.message}
                      </span>
                    </div>
                  </div>
                  <div className="md:w-1/2 md:pl-5">
                    <div>
                      <span className="block text-sm text-white mb-2">
                        {' '}
                        Email
                      </span>
                      <input
                        type="email"
                        id="email"
                        className="w-full mb-4 border rounded py-1 px-3 border-gray-300"
                        name="email"
                        {...register('email', {
                          required: i18n._(`Email không được để trống`),
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: i18n._(`Email không đúng định dạng`),
                          },
                        })}
                        placeholder={i18n._(`Địa chỉ email...`)}
                      />
                      <span className="block eemail text-red-500 text-xs">
                        {errors.email?.message}
                      </span>
                    </div>
                    <div>
                      <span className="block text-sm text-white mb-2">
                        {' '}
                        <Trans>Tài khoản đăng nhập</Trans>
                      </span>
                      <input
                        type="text"
                        id="login"
                        className="w-full mb-4 border rounded py-1 px-3 border-gray-300"
                        name="login"
                        {...register('login', {
                          required: i18n._(
                            `Tài khoản đăng nhập không được để trống`,
                          ),
                          pattern: {
                            value:
                              /^[a-zA-Z0-9]([._-](?![._-])|[a-zA-Z0-9]){0,18}[a-zA-Z0-9]$/i,
                            message: i18n._(
                              `Tên đăng nhập không đúng định dạng. Ví dụ: abc_1 abc-1 abc.1`,
                            ),
                          },
                        })}
                        placeholder={i18n._(`Tài khoản`)}
                      />
                      <span className="block text-red-500 text-xs">
                        {errors.login?.message}
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  className="font-bold text-white mb-3"
                  style={{ fontSize: '22px' }}
                >
                  <Trans> Thông tin tổ chức</Trans>
                </div>
                <div className="sm:flex w-full mb-0.5  text-sm">
                  <div className="w-full sm:w-1/2 sm:pr-5">
                    <div className="mb-4">
                      <span className="block mb-2.5 text-sm text-white">
                        <Trans>Tên tổ chức</Trans>
                      </span>
                      <input
                        type="text"
                        id="name"
                        className="w-full border rounded py-1.5 px-3 border-gray-300 mb-2"
                        name="name"
                        {...register('name', {
                          required: i18n._(
                            `Tên doanh nghiệp không được để trống`,
                          ),
                        })}
                      />
                      <span className="block errOrgName text-red-500 text-xs">
                        {errors.name?.message}
                      </span>
                    </div>
                    <div className="w-full mb-4">
                      <span className="block mb-2 text-sm text-white">
                        <Trans>Địa chỉ</Trans>
                      </span>
                      <div className="flex justify-between">
                        <div className="w-1/2 mr-2">
                          <span className="block mb-2 text-white ">
                            <Trans>Quốc gia</Trans>
                          </span>
                          <ReactSelect
                            name="nationId"
                            id="nationId"
                            onChange={(e) => {
                              hanldeGetProvinces(e.value);
                              setSelectedNation(e.value);
                            }}
                            options={nations.map((item) => {
                              return {
                                value: item.id,
                                label: item.name,
                              };
                            })}
                            className="nationId rounded w-full mb-2"
                            placeholder={i18n._(`Quốc gia`)}
                          />

                          <span className="block errCountry text-red-500 text-xs"></span>
                        </div>
                        <div className="w-1/2 ml-2">
                          <span className="block mb-2 text-sm text-white">
                            <Trans>Thành phố</Trans>
                          </span>
                          <ReactSelect
                            name="provinceId"
                            id="provinceId"
                            onChange={(e) => {
                              setSelectedProvinces(e.value);
                            }}
                            options={provinces.map((item) => {
                              return {
                                value: item.id,
                                label: item.name,
                              };
                            })}
                            className="provinceId rounded w-full mb-2"
                            placeholder={i18n._(`Thành phố`)}
                          />
                          <span className="block errCity text-red-500 text-xs mb-6"></span>
                        </div>
                      </div>
                      <div className="w-full mb-2.5">
                        <span className="block mb-2.5 text-sm text-white">
                          <Trans> Địa chỉ chi tiết</Trans>
                        </span>
                        <input
                          type="text"
                          id="orgAddress"
                          className="w-full border rounded py-1.5 px-3 border-gray-300 mb-2"
                          name="orgAddress"
                          {...register('orgAddress')}
                          placeholder={i18n._(
                            `Quận, huyện, phường xã, số nhà, ...`,
                          )}
                        />
                        <span className="block errStreet text-red-500 text-xs"></span>
                      </div>
                    </div>
                  </div>
                  <div className="w-full sm:w-1/2 sm:pl-5">
                    <div>
                      <span className="block mb-2.5 text-sm text-white">
                        Website
                      </span>
                      <input
                        type="text"
                        id="website"
                        className="w-full border rounded mb-6 py-1.5 px-3 border-gray-300"
                        name="website"
                        {...register('website')}
                      />
                      <span className="block errWebsite text-red-500 text-xs "></span>
                    </div>
                    <div className="w-full">
                      <div className="w-full mb-2.5 ">
                        <span className=" block mb-2 text-white text-sm">
                          <Trans>Email tổ chức</Trans>
                        </span>
                        <span className=" text-white text-sm">
                          <Trans>( Xác thực thông tin tổ chức )</Trans>
                        </span>
                      </div>
                      <input
                        type="email"
                        id="orgEmail"
                        className="w-full border rounded py-1.5 px-3 border-gray-300"
                        name="orgEmail"
                        {...register('orgEmail', {
                          required: i18n._(`Email tổ chức không được để trống`),
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: 'Email không đúng định dạng',
                          },
                        })}
                      />
                      <span className="block errUemail mb-6 text-red-500 text-xs">
                        {errors.orgEmail?.message}
                      </span>
                    </div>
                    <div>
                      <span className="block mb-2.5 text-white text-sm">
                        <Trans>Lĩnh vực hoạt động</Trans>
                      </span>
                      <ReactSelect
                        isMulti
                        options={fields.map((item) => {
                          return {
                            value: item.id,
                            label: lang == 'vi-VN' ? item.nameVi : item.nameEn,
                          };
                        })}
                        placeholder={i18n._('Lĩnh vực')}
                        onChange={(e) => setSelectedFields(e.value)}
                        name="linhvuc"
                        id="linhvuc"
                        className="fields border w-full rounded text-sm mb-2"
                      />
                      <span className="block errFields text-red-500 text-xs"></span>
                    </div>
                  </div>
                </div>
                <div className="flex gap-x-1 items-start mb-1">
                  <input
                    type="checkbox"
                    id="myCheckbox"
                    name="myCheckbox"
                    className={`form-checkbox h-4 w-4 rounded-[3px] mt-1`}
                    {...register('myCheckbox', {
                      required: i18n._(
                        `Bạn phải đồng ý với điều khoản và điều kiện!`,
                      ),
                    })}
                  />
                  <div className="text-[#FFFFFF] font-medium text-[14px]">
                    Tôi đồng ý với các{' '}
                    <span className="underline">điều khoản và điều kiện</span>{' '}
                    của VINet
                  </div>
                </div>
                <span className="block efname text-red-500 text-xs mb-10">
                  {errors.myCheckbox?.message}
                </span>

                <div className="w-full flex justify-center mb-10">
                  <button
                    className="px-10 py-2 rounded text-white"
                    type="submit"
                    id="btnRegister"
                    style={{ backgroundColor: ' rgba(242, 111, 39, 1)' }}
                  >
                    <Trans>Đăng ký</Trans>
                  </button>
                </div>
              </form>
              {allow2Oauth === true && (
                <>
                  <div className={'lg:block md:hidden mx-auto pt-7 flex'}>
                    <SocialSignup
                      redirect={
                        query.get('redirect') || `${DEFAULT_REDIRECT_URI}/o/0`
                      }
                    />
                  </div>
                </>
              )}
              <div className="sm:flex text-center w-full justify-center items-center mt-4">
                <div className=" mr-3 text-white">
                  <Trans>Bạn đã có tài khoản ?</Trans>
                </div>
                <div>
                  <Link
                    to={`/login${
                      redirectParam ? `?redirect=${redirectParam}` : ''
                    }`}
                  >
                    <div className="text-white underline font-medium ">
                      <Trans>Nhấn vào đây để đăng nhập</Trans>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="block">
          <div className="content-register">
            <div
              className=" mb-1"
              style={{ fontWeight: '600', fontSize: '26px', color: '#fff' }}
            >
              {type == 2 && (
                <span>
                  <Trans>
                    Đăng ký trang <br /> tổ chức giáo dục
                  </Trans>
                </span>
              )}
              {type == 3 && (
                <span>
                  <Trans>Đăng ký trang doanh nghiệp</Trans>
                </span>
              )}
            </div>
            <div className="h-1 mb-8 bg-white" style={{ width: '59px' }}></div>
            <div
              className="font-semibold text-white mb-3"
              style={{ fontSize: '20px' }}
            >
              <Trans>Thông tin cá nhân đại diện</Trans>
            </div>
            <div className="">
              <form method="post" onSubmit={handleSubmit(onSubmit)}>
                <div className="md:flex w-full mb-8">
                  <div className="md:w-1/2 md:pr-5">
                    <div className="md:flex">
                      <div className="md:mr-2">
                        <span className="block mb-2 text-sm text-white font-medium">
                          <Trans>Họ *</Trans>
                        </span>
                        <input
                          type="text"
                          id="lastName"
                          className="w-full mb-1 border rounded py-1 px-3 border-gray-300"
                          name="lastName"
                          placeholder={i18n._(`Nhập tên tổ chức`)}
                          {...register('lastName', {
                            required: i18n._(`Vui lòng điền họ`),
                          })}
                        />
                        <span className="block efname text-[#EAA985] text-xs">
                          {errors.lastName?.message}
                        </span>
                      </div>
                      <div className="md:ml-2">
                        <span className="block mb-2 text-sm text-white font-medium">
                          <Trans>Tên *</Trans>
                        </span>
                        <input
                          type="text"
                          id="firstName"
                          className="w-full mb-1 border rounded py-1 px-3 border-gray-300"
                          name="firstName"
                          placeholder={i18n._(`Nhập tên`)}
                          {...register('firstName', {
                            required: i18n._(`Vui lòng điền tên`),
                          })}
                        />
                        <span className="block text-[#EAA985] text-xs">
                          {errors.firstName?.message}
                        </span>
                      </div>
                      <div className="md:w-1/2 md:pl-5">
                        <div>
                          <span className="block text-sm text-white mb-2 font-medium">
                            {' '}
                            Email *
                          </span>
                          <input
                            type="email"
                            id="email"
                            className="w-full mb-1 border rounded py-1 px-3 border-gray-300"
                            name="email"
                            {...register('email', {
                              required: i18n._(`Email không được để trống`),
                              pattern: {
                                value:
                                  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: i18n._(`Email không đúng định dạng`),
                              },
                            })}
                            placeholder={i18n._(`Nhập email`)}
                          />
                          <span className="block eemail text-[#EAA985] text-xs">
                            {errors.email?.message}
                          </span>
                        </div>
                        <div>
                          <span className="block text-sm text-white mb-2 font-medium">
                            {' '}
                            <Trans>Tài khoản đăng nhập *</Trans>
                          </span>
                          <input
                            type="text"
                            id="login"
                            className="w-full mb-1 border rounded py-1 px-3 border-gray-300"
                            name="login"
                            {...register('login', {
                              required: i18n._(
                                `Tài khoản đăng nhập không được để trống`,
                              ),
                              pattern: {
                                value:
                                  /^[a-zA-Z0-9]([._-](?![._-])|[a-zA-Z0-9]){0,18}[a-zA-Z0-9]$/i,
                                message: i18n._(
                                  `Tên đăng nhập không đúng định dạng. Ví dụ: abc_1 abc-1 abc.1`,
                                ),
                              },
                            })}
                            placeholder={i18n._(`Nhập tài khoản`)}
                          />
                          <span className="block text-[#EAA985] text-xs">
                            {errors.login?.message}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <span className="block mb-2 text-sm text-white font-medium">
                        <Trans>Mật khẩu *</Trans>
                      </span>
                      <div className="relative flex">
                        <input
                          id="password"
                          className="w-full mb-1 border rounded py-1 px-3 border-gray-300"
                          name="password"
                          {...register('password', {
                            required: i18n._(`Vui lòng điền mật khẩu`),
                            minLength: {
                              value: 6,
                              message: t`Mật khẩu tối thiểu 6 ký tự`,
                            },
                          })}
                          placeholder={i18n._(`Nhập mật khẩu`)}
                          type={passwordShown ? 'text' : 'password'}
                        />
                        <div
                          onClick={togglePasswordVisiblity}
                          className="absolute right-[13px] translate-y-1/3 -translate-x-1/2"
                        >
                          {passwordShown ? (
                            <img src={showPass} />
                          ) : (
                            <img src={hidePass} />
                          )}
                        </div>
                      </div>
                      <span className="block epassword text-[#EAA985] text-xs">
                        {errors.password?.message}
                      </span>
                    </div>
                    <div>
                      <span className="block mb-2 text-sm text-white font-medium">
                        <Trans>Mật khẩu xác nhận *</Trans>
                      </span>
                      <div className="relative flex">
                        <input
                          id="repassword"
                          {...register('repassword', {
                            required: i18n._(`Không được để trống`),
                            validate: (value) =>
                              value === password.current ||
                              i18n._(`Mật khẩu không khớp`),
                          })}
                          className="w-full mb-1 border rounded py-1 px-3 border-gray-300"
                          placeholder={i18n._(`Nhập lại mật khẩu`)}
                          type={rePasswordShown ? 'text' : 'password'}
                        />
                        <div
                          onClick={toggleRePasswordVisiblity}
                          className="absolute right-[13px] translate-y-1/3 -translate-x-1/2"
                        >
                          {rePasswordShown ? (
                            <img src={showPass} />
                          ) : (
                            <img src={hidePass} />
                          )}
                        </div>
                      </div>
                      <span className="block erepassword text-[#EAA985] text-xs">
                        {errors.repassword?.message}
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  className="font-semibold text-white mb-3"
                  style={{ fontSize: '20px' }}
                >
                  <Trans> Thông tin tổ chức</Trans>
                </div>
                <div className="sm:flex w-full mb-0.5  text-sm">
                  <div className="w-full sm:w-1/2 sm:pr-5">
                    <div className="mb-4">
                      <span className="block mb-2 text-sm text-white font-medium">
                        <Trans>Tên tổ chức *</Trans>
                      </span>
                      <input
                        type="text"
                        id="name"
                        className="w-full border rounded py-1.5 px-3 border-gray-300 mb-1"
                        name="name"
                        placeholder={i18n._(`Nhập tên tổ chức`)}
                        {...register('name', {
                          required: i18n._(
                            `Tên doanh nghiệp không được để trống`,
                          ),
                        })}
                      />
                      <span className="block errOrgName text-[#EAA985] text-xs">
                        {errors.name?.message}
                      </span>
                    </div>
                    <div className="w-full mb-4">
                      <span className="block mb-2 text-sm text-white font-medium">
                        <Trans>Địa chỉ</Trans>
                      </span>
                      <div className="flex flex-col justify-between">
                        <div className="w-full">
                          <span className="block mb-2 text-white font-medium ">
                            <Trans>Quốc gia</Trans>
                          </span>
                          <ReactSelect
                            name="nationId"
                            id="nationId"
                            onChange={(e) => {
                              hanldeGetProvinces(e.value);
                              setSelectedNation(e.value);
                            }}
                            options={nations.map((item) => {
                              return {
                                value: item.id,
                                label: item.name,
                              };
                            })}
                            className="nationId rounded w-full mb-1"
                            placeholder={i18n._(`Quốc gia`)}
                          />

                          <span className="block errCountry text-[#EAA985] text-xs"></span>
                        </div>
                        <div className="w-full">
                          <span className="block mb-1 text-sm text-white font-medium">
                            <Trans>Thành phố</Trans>
                          </span>
                          <ReactSelect
                            name="provinceId"
                            id="provinceId"
                            onChange={(e) => {
                              setSelectedProvinces(e.value);
                            }}
                            options={provinces.map((item) => {
                              return {
                                value: item.id,
                                label: item.name,
                              };
                            })}
                            className="provinceId rounded w-full mb-2"
                            placeholder={i18n._(`Thành phố`)}
                          />
                          <span className="block errCity text-[#EAA985] text-xs mb-6"></span>
                        </div>
                      </div>
                      <div className="w-full mb-2.5">
                        <span className="block mb-2 text-sm text-white font-medium">
                          <Trans> Địa chỉ chi tiết</Trans>
                        </span>
                        <input
                          type="text"
                          id="orgAddress"
                          className="w-full border rounded py-1.5 px-3 border-gray-300 mb-2"
                          name="orgAddress"
                          {...register('orgAddress')}
                          placeholder={i18n._(
                            `Quận, huyện, phường xã, số nhà, ...`,
                          )}
                        />
                        <span className="block errStreet text-[#EAA985] text-xs h-8">
                          Không được để trống
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="w-full sm:w-1/2 sm:pl-5">
                    <div>
                      <span className="block mb-2 text-sm text-white font-medium">
                        Website
                      </span>
                      <input
                        type="text"
                        id="website"
                        className="w-full border rounded mb-1 py-1.5 px-3 border-gray-300"
                        name="website"
                        placeholder={i18n._(`Nhập website`)}
                        {...register('website')}
                      />
                      <span className="block errWebsite text-[#EAA985] text-xs "></span>
                    </div>
                    <div className="w-full">
                      <div className="w-full mb-2.5 ">
                        <span className=" block mb-2 text-white text-sm font-medium">
                          <Trans>Email lãnh đạo *</Trans>
                        </span>
                        <span className=" text-white text-sm font-medium">
                          <Trans>( Xác thực thông tin tổ chức )</Trans>
                        </span>
                      </div>
                      <input
                        type="email"
                        id="orgEmail"
                        className="w-full border rounded py-1.5 px-3 border-gray-300 mb-1"
                        name="orgEmail"
                        placeholder={i18n._(`Nhập email lãnh đạo`)}
                        {...register('orgEmail', {
                          required: i18n._(`Email tổ chức không được để trống`),
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: 'Email không đúng định dạng',
                          },
                        })}
                      />
                      <span className="block errUemail mb-6 text-[#EAA985] text-xs">
                        {errors.orgEmail?.message}
                      </span>
                    </div>
                    <div>
                      <span className="block mb-2.5 text-white text-sm font-medium">
                        <Trans>Lĩnh vực hoạt động</Trans>
                      </span>
                      <ReactSelect
                        isMulti
                        options={fields.map((item) => {
                          return {
                            value: item.id,
                            label: lang == 'vi-VN' ? item.nameVi : item.nameEn,
                          };
                        })}
                        placeholder={i18n._('Chọn lĩnh vực hoạt động')}
                        onChange={(e) => setSelectedFields(e.value)}
                        name="linhvuc"
                        id="linhvuc"
                        className="fields border w-full rounded text-sm mb-2"
                      />
                    </div>
                  </div>
                </div>
                <div className="flex gap-x-1 items-start mb-1">
                  <input
                    type="checkbox"
                    id="myCheckbox"
                    name="myCheckbox"
                    className={`form-checkbox h-4 w-4 rounded-[3px] mt-1`}
                    {...register('myCheckbox', {
                      required: i18n._(
                        `Bạn phải đồng ý với điều khoản và điều kiện!`,
                      ),
                    })}
                  />
                  <div className="text-[#FFFFFF] font-medium text-[14px]">
                    Tôi đồng ý với các{' '}
                    <span className="underline">điều khoản và điều kiện</span>{' '}
                    của VINet
                  </div>
                </div>
                <span className="block efname text-[#EAA985] text-xs mb-10">
                  {errors.myCheckbox?.message}
                </span>

                <div className="w-full flex justify-center mb-8">
                  <button
                    className="px-10 py-2 w-[270px] h-[48px] font-medium rounded-[8px] text-white"
                    type="submit"
                    id="btnRegister"
                    style={{ backgroundColor: ' rgba(242, 111, 39, 1)' }}
                  >
                    <Trans>Đăng ký</Trans>
                  </button>
                </div>
              </form>
              {allow2Oauth === true && (
                <>
                  <div
                    className={'lg:block md:hidden mx-auto justify-center flex'}
                  >
                    <SocialSignup
                      redirect={
                        query.get('redirect') || `${DEFAULT_REDIRECT_URI}/o/0`
                      }
                    />
                  </div>
                </>
              )}
              <div className="flex text-center w-full justify-center items-center mt-4">
                <div className="text-[14px] text-white">
                  <Trans>Bạn đã có tài khoản?</Trans>
                </div>
                <div>
                  <Link
                    to={`/login${
                      redirectParam ? `?redirect=${redirectParam}` : ''
                    }`}
                  >
                    <div className="ml-1 text-white text-[14px] underline font-medium ">
                      <Trans>Nhấn vào đây để đăng nhập</Trans>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrganizationForm;
